var map = {
	"./photo-1475189778702-5ec9941484ae.avif": 3407,
	"./photo-1483729558449-99ef09a8c325.avif": 6156,
	"./photo-1501446529957-6226bd447c46.avif": 5981,
	"./photo-1503177119275-0aa32b3a9368.avif": 8117,
	"./photo-1546768292-fb12f6c92568.avif": 6712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;